import React, { useEffect, useState } from "react"
import { Cidade, ClientesAttributes, ItensVendas, RelatorioConsultaVendas } from "../../../Utils/Types"
import Logo4 from '../../../assets/imagens/Logo4.png'
import moment from "moment"
import { ClientesService } from "../../Clientes/ClientesService"
import { Funcoes } from "../../../Utils/Funcoes"

export type Props = {
    visible: boolean,
    dadosVenda?: ItensVendas[],
    dadosCliente?: any,
    descricoesFiltradas?: any,
    parcelamentos?: any,
    dadosDesconto?: any,
    dadosReimpressao?: RelatorioConsultaVendas[],
    closeModalEvent: () => void
}

export const ReportVendaFinalizadaA4 = ({ visible, dadosVenda, dadosCliente, descricoesFiltradas, parcelamentos, dadosDesconto, dadosReimpressao, closeModalEvent }: Props) => {

    const [urlLogo, setUrlLogo] = useState(localStorage.getItem('imageLogo') || Logo4)
    const [dadosEmpresa, setDadosEmpresa] = useState<any>()
    //const [dadosDoCliente, setDadosDoCliente] = useState<ClientesAttributes>()
    //const [nomeCidade, setNomeCidade] = useState<Cidade>()
    //const [dadosDaVenda, setDadosDaVennda] = useState<ItensVendas[]>(dadosVenda)
    //const [loading, setLoading] = useState(true)

    useEffect(() => {
        setDadosEmpresa(Funcoes.GetDadosEmpresa())
    }, []);

    useEffect(() => {

        if (visible) {

            //getClientes()

            let modal = document.getElementById('modal_vendas_report_A4')
            let modalContent = document.getElementById('modal_content_vendas_report_A4')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-2000px]')
                    modalContent.classList.add('mt-2')
                }
            }

            const printContent = document.getElementById('modal_content_vendas_report_A4');

            if (printContent) {
                // Abrir uma nova aba
                const printWindow = window.open('novaJanela', 'width=800,height=400', '_blank');

                if (printWindow) {
                    // Escrever o conteúdo na nova aba
                    printWindow.document.open();
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Impressão</title>
                                                        <script src="https://cdn.tailwindcss.com"></script>
                                                    </head>
                                                    <body>${printContent.innerHTML}</body>
                                                </html>
                                            `);
                    printWindow.document.close();

                    if (typeof closeModalEvent === 'function') {
                        closeModalEvent();
                    }

                } else {
                    console.error("Não foi possível abrir uma nova aba para impressão.");
                }
            } else {
                console.error("Elemento do modal não encontrado.");
            }



        } else {

            let modal = document.getElementById('modal_vendas_report_A4');
            let modalContent = document.getElementById('modal_content_vendas_report_A4');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-2000px]');
                    modalContent.classList.remove('mt-2');
                }
            }

            //setNomeCidade(undefined)
            //setLoading(true)
        }

    }, [visible])

    useEffect(() => {
        setUrlLogo(localStorage.getItem('imageLogo') || Logo4)
    }, [localStorage.getItem('imageLogo')]);

    /*
    useEffect(() => {
        if (dadosEmpresa) {
            setLoading(false)
        }
    }, [dadosEmpresa]);
    */

    /*
    useEffect(() => {
        if (!loading) {
            window.print();
            setLoading(true)

            const timer = setTimeout(() => {

                closeModalEvent();
                clearTimeout(timer)
    
            }, 100)
        }
    }, [loading]);
    */

    /*
    useEffect(() => {
        if (dadosDoCliente) {
            setNomeCidade(dadosDoCliente.cidades.find((item: any) => item.id === dadosDoCliente.cliente.id_cidade));
            setLoading(false)
        }
    }, [dadosDoCliente]);
    */

    /*
    const getClientes = async () => {
        const cliente = await ClientesService.GetAttributes(dadosCliente?.id_consumidor || (dadosReimpressao && dadosReimpressao[0]?.id_cliente))
        setDadosDoCliente(cliente)
    }
    */

    /*
    const somarTotalVenda = (dadosVenda: ItensVendas[]) => {
        return dadosVenda.reduce((acumulador, item) => acumulador + item.vl_tot, 0);
    }
    */

    //let valorTotal = somarTotalVenda(dadosVenda || [])

    const lista = (dadosReimpressao && dadosReimpressao[0]?.pagamentos);
    const dados = (dadosReimpressao && dadosReimpressao[0]?.itens)

    return (

        <div id="modal_vendas_report_A4" style={{ visibility: "hidden" }} className="fixed top-0 bottom-0 left-0 right-0 z-40 flex justify-center transition-all duration-300">

            <div id="modal_content_vendas_report_A4" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'auto', borderRadius: '0.5rem', marginTop: '-2000px', transition: 'all 0.3s' }}>

                <div style={{ width: "210mm", minHeight: "500px", height: "auto", backgroundColor: "white", padding: '1rem' }}>

                    <div style={{ border: '1px solid black', height: 'auto', width: 'auto' }}>

                        <div style={{ display: 'flex', flexDirection: 'row' }}>

                            <div style={{ height: '70px', width: '20%', border: '1px solid black', borderTop: 'none', borderLeft: 'none', display: 'flex', justifyContent: 'center', padding: '1px' }}>
                                <img src={urlLogo} alt="Logo" style={{ width: '200px', height: '58px' }} />
                            </div>

                            <div style={{ height: '70px', width: '60%', border: '1px solid black', borderTop: 'none', borderRight: 'none', borderLeft: 'none', textAlign: 'center', fontSize: '12px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <span>DOCUMENTO AUXILIAR DE VENDA - ORÇAMENTO</span>
                                <span>NÃO É DOCUMENTO FISCAL - NÃO É VALIDO COMO RECIBO E COMO</span>
                                <span>GARANTIA DE MERCADORIA - NÃO COMPROVA PAGAMENTO</span>
                            </div>

                            <div style={{ height: '70px', width: '20%', border: '1px solid black', borderTop: 'none', borderRight: 'none', textAlign: 'center', fontSize: '14px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <span>Data / Hora</span>
                                <span>{(dadosReimpressao ? moment(dadosReimpressao[0]?.data_hora).format("DD/MM/YYYY HH:mm") : moment(new Date()).format("DD/MM/YYYY HH:mm"))}</span>
                            </div>

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row' }}>

                            <div style={{ minHeight: '80px', height: 'auto', width: '75%', border: '1px solid black', borderLeft: 'none', borderTop: 'none', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingLeft: '2px', gap: '2px' }}>
                                <span style={{ marginBottom: '3px' }}>{dadosEmpresa?.razao || ''}</span>
                                <span style={{ marginBottom: '3px' }}>{'CNPJ: ' + Funcoes.FormatDoc(dadosEmpresa?.cnpj_cpf)}</span>
                                <span style={{ marginBottom: '3px' }}>{dadosEmpresa?.endereco || ''}</span>
                                <span>{(dadosEmpresa?.cidade || '') + ' - ' + (dadosEmpresa?.uf || '') + ' - ' + (dadosEmpresa?.cep || '')}</span>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '2px', fontSize: '12px' }}>
                                    <span style={{ width: '30%' }}>{'CNPJ: ' + (Funcoes.FormatDoc(dadosEmpresa?.cnpj_cpf) || '')}</span>
                                    <span style={{ width: '30%' }}>{'Insc. Est.: ' + (dadosEmpresa?.ie || '')}</span>
                                    <span style={{ width: '40%' }}>{'Tel.: ' + (Funcoes.FormatTelefone(dadosEmpresa?.telefone) || '')}</span>
                                </div>
                            </div>

                            <div style={{ minHeight: '80px', height: 'auto', width: '25%', border: '1px solid black', borderTop: 'none', borderRight: 'none', borderLeft: 'none', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingLeft: '2px', wordBreak: 'break-all' }}>
                                <span>{'Obs.: ' + (dadosReimpressao ? (dadosReimpressao[0]?.observacao || '') : '')}</span>

                            </div>

                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row' }}>

                            <div style={{ minHeight: '80px', height: 'auto', width: '80%', border: '1px solid black', borderLeft: 'none', borderTop: 'none', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingLeft: '2px', gap: '2px' }}>

                                <span>{'Cliente: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.nome || '') : '')}</span>
                                <span>{'Fantasia: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.nome_fantasia || '') : '')}</span>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '2px', fontSize: '12px' }}>
                                    <span style={{ width: '70%' }}>{'Endereço: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.endereco || '') : '')}</span>
                                    <span style={{ width: '30%' }}>{'N° ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.numero || '') : '')}</span>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '2px', fontSize: '12px' }}>
                                    <span style={{ width: '50%' }}>{'Bairro: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.bairro || '') : '')}</span>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '50%' }}>
                                        <span>{'Cidade: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.nome_cidade || '') : '') + ' - ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.uf || '') : '') + ' - ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.cep || '') : '')}</span>
                                    </div>
                                </div>

                                <span>{'Complemento: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.complemento || '') : '')}</span>

                                <div style={{ display: 'flex', flexDirection: 'row', gap: '2px', fontSize: '12px' }}>
                                    <span style={{ width: '32%' }}>{'CNPJ/CPF: ' + (dadosReimpressao ? (Funcoes.FormatDoc(dadosReimpressao[0]?.DadosCliente.cnpj_cpf) || '') : '')}</span>
                                    <span style={{ width: '22%' }}>{'IE/RG: ' + (dadosReimpressao ? (dadosReimpressao[0]?.DadosCliente.ie_rg || '') : '')}</span>
                                    <span style={{ width: '23%' }}>{'Fone: ' + (dadosReimpressao ? (Funcoes.FormatTelefone(dadosReimpressao[0]?.DadosCliente.contato.telefone) || '') : '')}</span>
                                    <span style={{ width: '23%' }}>{'Cel: ' + (dadosReimpressao ? (Funcoes.FormatCelular(dadosReimpressao[0]?.DadosCliente.contato.celular) || '') : '')}</span>
                                </div>

                            </div>

                            <div style={{ minHeight: '80px', height: 'auto', width: '20%', border: '1px solid black', borderLeft: 'none', borderTop: 'none', borderRight: 'none', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingLeft: '2px' }}>
                                <span>{'N° Documento:'}</span>
                                <span>{(dadosReimpressao ? (dadosReimpressao[0]?.id || '') : '')}</span>
                            </div>

                        </div>

                        <table style={{ marginTop: '0rem', width: '100%' }}>

                            <thead>
                                <tr>
                                    <th style={{ width: '15%', fontSize: '12px', textAlign: 'left', padding: '2px 3px 2px 3px' }}>Código</th>
                                    <th style={{ width: '50%', fontSize: '12px', textAlign: 'left', padding: '2px 3px 2px 3px' }}>Descrição</th>
                                    <th style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '2px 3px 2px 3px' }}>Qtde</th>
                                    <th style={{ width: '5%', fontSize: '12px', textAlign: 'left', padding: '2px 5px 2px 5px' }}>Unid</th>
                                    <th style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '2px 5px 2px 5px' }}>Vr. Unit</th>
                                    <th style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '2px 3px 2px 3px' }}>Valor Total</th>
                                </tr>
                             
                            </thead>
                            <tbody>
                                {dados?.map((item: any, index: any) => (
                                     <React.Fragment key={index}>
                                        <tr>
                                            <td style={{ width: '15%', fontSize: '12px', textAlign: 'left', padding: '1px 3px 1px 3px' }}>{item.cod_barra || ''}</td>
                                            <td style={{ width: '50%', fontSize: '12px', textAlign: 'left', padding: '1px 3px 1px 3px' }}>{item.desc_prod || ''}</td>
                                            <td style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '1px 3px 1px 3px' }}>{Funcoes.numberFormat(item.qtde || 0, 'decimal')}</td>
                                            <td style={{ width: '5%', fontSize: '12px', textAlign: 'left', padding: '1px 5px 1px 5px' }}>{item.desc_unid_medida || ''}</td>
                                            <td style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '1px 5px 1px 5px' }}>{Funcoes.numberFormat(item.vl_unit || 0, 'decimal')}</td>
                                            <td style={{ width: '10%', fontSize: '12px', textAlign: 'right', padding: '1px 3px 1px 3px' }}>{Funcoes.numberFormat(item.vl_tot || 0, 'decimal')}</td>
                                        </tr>
                                        {item.observacao && (
                                            <tr>
                                                <td colSpan={6} style={{ fontSize: '12px', textAlign: 'left', padding: '1px 3px 1px 3px', color: '#555' }}>
                                                    <strong>Obs:</strong> {item.observacao}
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>

                        </table>

                        <div style={{ marginTop: '1rem', width: '100%' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: '12px' }}>
                                <span style={{ marginLeft: '0.25rem' }}>Formas de Pag.: </span>
                                {lista?.map((item: { descricao: string, valor: number }, index: number) => (
                                    <div key={index} style={{ textAlign: 'start', padding: '0 0.25rem' }}>
                                        {(item.descricao || '') + '(' + Funcoes.numberFormat(item.valor, 'currency') + ')'}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {(dadosReimpressao && dadosReimpressao[0]?.Crediario.length > 0) && (
                            <div style={{ marginTop: '1rem', width: '100%', display: 'flex' }}>

                                <table style={{ width: '50%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '15%', fontSize: '12px', textAlign: 'start', padding: '0 0.25rem' }}>Duplicata</th>
                                            <th style={{ width: '25%', fontSize: '12px', textAlign: 'center', padding: '0 0.25rem' }}>Vencimento</th>
                                            <th style={{ width: '15%', fontSize: '12px', textAlign: 'end', padding: '0 0.25rem' }}>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dadosReimpressao &&
                                            dadosReimpressao[0]?.Crediario
                                                .filter((_: any, index: any) => index % 2 === 0) // Índices pares
                                                .map((item: any, index: any) => (
                                                    <tr key={index}>
                                                        <td style={{ width: '15%', fontSize: '12px', textAlign: 'start', padding: '0 0.25rem' }}>
                                                            {(item.serie || '')}
                                                        </td>
                                                        <td style={{ width: '25%', fontSize: '12px', textAlign: 'center', padding: '0 0.25rem' }}>
                                                            {(moment(item.data_vencimento).format("DD/MM/YYYY") || '')}
                                                        </td>
                                                        <td style={{ width: '15%', fontSize: '12px', textAlign: 'end', padding: '0 0.25rem' }}>
                                                            {Funcoes.numberFormat(item.valor || 0, 'decimal')}
                                                        </td>
                                                    </tr>
                                                ))}
                                    </tbody>
                                </table>

                                <table style={{ width: '50%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '15%', fontSize: '12px', textAlign: 'start', padding: '0 0.25rem' }}>Duplicata</th>
                                            <th style={{ width: '25%', fontSize: '12px', textAlign: 'center', padding: '0 0.25rem' }}>Vencimento</th>
                                            <th style={{ width: '15%', fontSize: '12px', textAlign: 'end', padding: '0 0.25rem' }}>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dadosReimpressao &&
                                            dadosReimpressao[0]?.Crediario
                                                .filter((_: any, index: any) => index % 2 !== 0) // Índices ímpares
                                                .map((item: any, index: any) => (
                                                    <tr key={index}>
                                                        <td style={{ width: '15%', fontSize: '12px', textAlign: 'start', padding: '0 0.25rem' }}>
                                                            {(item.serie || '')}
                                                        </td>
                                                        <td style={{ width: '25%', fontSize: '12px', textAlign: 'center', padding: '0 0.25rem' }}>
                                                            {(moment(item.data_vencimento).format("DD/MM/YYYY") || '')}
                                                        </td>
                                                        <td style={{ width: '15%', fontSize: '12px', textAlign: 'end', padding: '0 0.25rem' }}>
                                                            {Funcoes.numberFormat(item.valor || 0, 'decimal')}
                                                        </td>
                                                    </tr>
                                                ))}
                                    </tbody>
                                </table>

                            </div>
                        )}

                        <div style={{ border: '1px solid black', borderLeft: '0', borderRight: '0', borderBottom: '0', display: 'flex', flexDirection: 'row', fontSize: '12px', height: 'auto' }}>

                            <span style={{ width: '40%', minHeight: '30px', border: '1px solid black', borderLeft: '0', borderTop: '0', borderBottom: '0', display: 'flex', alignItems: 'center', paddingLeft: '0.25rem' }}>Vendedor:</span>
                            <span style={{ width: '40%', minHeight: '30px', border: '1px solid black', borderLeft: '0', borderTop: '0', borderBottom: '0', display: 'flex', alignItems: 'center', paddingLeft: '0.25rem' }}>Comprador:</span>

                            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '30px' }}>
                                <span style={{ paddingLeft: '0.25rem' }}>{'Desconto: ' + (dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_desc, 'decimal') : '')}</span>
                                <span style={{ paddingLeft: '0.25rem' }}>{'Troco: ' + (dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_troco, 'decimal') : '')}</span>
                                <span style={{ paddingLeft: '0.25rem' }}>{'Total: ' + (dadosReimpressao ? Funcoes.numberFormat(dadosReimpressao[0]?.vl_bruto - dadosReimpressao[0]?.vl_desc, 'decimal') : '')}</span>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    )

}